import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import AssessmentsEdit from "../../../../components/assessments/AssessmentsEdit.tsx";
import {config} from "../../../../config/config.ts";
import {UserRole} from "../../../../constants.ts";
import Header from "../../../../Header.tsx";
import {useJwtUser} from "../../../../JWTAuthProvider.tsx";

export const Route = createFileRoute('/_app/abilities/$assessment_uid/')({
    component: RouteComponent,
})

function RouteComponent() {
    const user = useJwtUser();

    return <>
        <Header backUrl={user?.role === UserRole.Player ? '/abilities' : '/organizer/assessments'} />

        <div className={"max-w-6xl w-11/12 mx-auto"}>
            <AssessmentsEdit />
        </div>
    </>
}
